<template lang="pug">
  v-row(justify='center')
    v-dialog(v-model='openModalNotif' persistent='' max-width='380')
      //- template(v-slot:activator='{ on, attrs }')
      //-   v-btn(color='primary' dark='' v-bind='attrs' v-on='on')
      //-     | Open Dialog
      v-card(height="180px" style="text-align:center; padding:40px 30px 40px 30px")
        v-card-text()
          h2 Petugas masih terikat izin kerja yang sedang berjalan!
        v-card-actions(style="margin-top:10px")
          v-spacer
          v-btn(style="margin-right:120px" text='' @click='handleClose()')
            | OK
</template>

<script>
export default {
name:"ModalNotifWaskat",
props:['openModalNotif','onClose'],

 data () {
      return {
        dialog: false,
      }
    },
  methods: {
    handleClose(){
      this.$emit("onClose", false)
    },
  }
}
</script>

<style>

</style>